import apiClient from 'ps-components/lib/apiClient';

export const SURVEY_LIBRARY_UPDATE_AGREEMENT_SUBMIT = 'SURVEY_LIBRARY_UPDATE_AGREEMENT_SUBMIT';
export const SURVEY_LIBRARY_UPDATE_AGREEMENT_SUBMIT_SUCCESS = 'SURVEY_LIBRARY_UPDATE_AGREEMENT_SUBMIT_SUCCESS';
export const SURVEY_LIBRARY_UPDATE_AGREEMENT_SUBMIT_FAILURE = 'SURVEY_LIBRARY_UPDATE_AGREEMENT_SUBMIT_FAILURE';
export const SURVEY_LIBRARY_UPDATE_AGREEMENT_SUBMIT_RESET = 'SURVEY_LIBRARY_UPDATE_AGREEMENT_SUBMIT_RESET';

export const SURVEY_LIBRARY_UPDATE_AGREEMENT_INIT = 'SURVEY_LIBRARY_UPDATE_AGREEMENT_INIT';
export const SURVEY_LIBRARY_UPDATE_AGREEMENT_UPDATE_SIGNATURE = 'SURVEY_LIBRARY_UPDATE_AGREEMENT_UPDATE_SIGNATURE';
export const SURVEY_LIBRARY_UPDATE_AGREEMENT_UPDATE_ACCEPTANCE = 'SURVEY_LIBRARY_UPDATE_AGREEMENT_UPDATE_ACCEPTANCE';
export const SET_SUBMIT_STATUS = 'SET_SUBMIT_STATUS';

export const initializeAgreement = () => {
  return { type: SURVEY_LIBRARY_UPDATE_AGREEMENT_INIT };
};

export const closeError = () => {
  return { type: SURVEY_LIBRARY_UPDATE_AGREEMENT_SUBMIT_RESET };
};

export const submitAgreement = () => async (dispatch, getState) => {
  dispatch({ type: SURVEY_LIBRARY_UPDATE_AGREEMENT_SUBMIT });
  const { userSignature, emailEnabled } = getState().surveyLibraryUpdateAgreement;

  try {
    const result = await apiClient.apiPost('/api/slu/agreement/signAgreement', {
      userSignature,
      emailEnabled
    });
    if (result.data.success) {
      dispatch({ type: SURVEY_LIBRARY_UPDATE_AGREEMENT_SUBMIT_SUCCESS });
    } else {
      dispatch({ type: SURVEY_LIBRARY_UPDATE_AGREEMENT_SUBMIT_FAILURE, payload: result.data.message });
    }
  } catch (err) {
    dispatch({ type: SURVEY_LIBRARY_UPDATE_AGREEMENT_SUBMIT_FAILURE, payload: err });
  }

  //  TODO: Implement Success / Failure
};

export const updateUserSignature = e => {
  return {
    type: SURVEY_LIBRARY_UPDATE_AGREEMENT_UPDATE_SIGNATURE,
    payload: e.target.value
  };
};

export const updateUserAcceptance = () => {
  return {
    type: SURVEY_LIBRARY_UPDATE_AGREEMENT_UPDATE_ACCEPTANCE
  };
};

export const setSubmitStatus = submitStatus => {
  return { type: SET_SUBMIT_STATUS, submitStatus };
};
